import { PAGE_TYPE } from '@utils/constants';

export const setKebabMenuOptions = (
  isDefaultLandingPage,
  landingPageEnabled = false,
  isShareEnabled = false,
  isSaveEnabled = false,
  pageType = null,
) => {
  const newKebabItems: any = [];

  if (landingPageEnabled) {
    newKebabItems.push({
      key: 'set-default-landing-page',
      label: 'Make default',
      disabled: isDefaultLandingPage,
    });
  }

  if (isShareEnabled) {
    newKebabItems.push({
      key: 'share',
      label: 'Share',
    });
  }

  if (isSaveEnabled) {
    newKebabItems.push({
      key: 'save',
      label: 'Save',
    });
  }
  if (pageType === PAGE_TYPE.SAVED_DASHBOARD) {
    newKebabItems.push({
      key: 'delete',
      label: 'Delete',
    });
  }

  return newKebabItems;
};
